import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import Text from '../../components/Text';
import { imageGallerySettingsConstants } from '../../constants/globalConstant';

const GalleryGridView = ({ widgetInformation, imgUrls }) => {
  const ref = useRef();
  const { title, size, frame } = widgetInformation;
  const imageSize = size.match(/Small|Medium|Large/i);

  return (
    <div className={styles['gallery-container']} data-testid="gallery-grid-view">
      <div className="flex flex-row justify-content-between align-items-center mx-2 mt-1">
        <Text type="sub-heading-bold" color="var(--text-focused)">
          {title}
        </Text>
      </div>
      <div
        data-testid="gallery-grid-box"
        className={`${styles['gallery-grid-box']} ${styles[`grid-${imageSize[0].toLowerCase()}`]}`}>
        {imgUrls?.map((element) => {
          return (
            <div
              data-testid={`gallery-element-box-${element.id}`}
              key={element.id}
              className={`${styles['img-container']} ${frame && styles['img-container-frame']}`}>
              <div
                ref={ref}
                className={`${styles['image']}`}
                style={{ height: `${ref?.current?.offsetWidth}` }}>
                <img
                  crossOrigin="anonymous"
                  src={`${element.imageURL}`}
                  alt="Gallery-Image"
                  className="product-image w-full"
                  onError={(e) =>
                    (e.target.src = `${imageGallerySettingsConstants.DEMO_SQUARE_IMAGE}`)
                  }
                />
              </div>
              <Text type="mobile-T5" color="#627087" className={`word-break`}>
                {element.label}
              </Text>
            </div>
          );
        })}
      </div>
    </div>
  );
};

GalleryGridView.propTypes = {
  elementList: PropTypes.array
};

export default GalleryGridView;
